import {
  APP_ALERT,
  APP_ALERT_DISMISS,
  APP_CONFIRM,
  APP_CONFIRM_DISMISS,
  APP_PROMPT,
  APP_PROMPT_DISMISS,
  APP_NOTIFY,
} from 'app/actions/app';

export default (
  state = {
    dialogs: [],
    notifications: [],
  },
  action
) => {
  let dialogs;
  switch (action.type) {
    case APP_ALERT:
      dialogs = state.dialogs || [];
      dialogs = dialogs.concat({ type: 'alert', message: action.message });
      return { ...state, dialogs };
    case APP_CONFIRM_DISMISS:
    case APP_PROMPT_DISMISS:
    case APP_ALERT_DISMISS:
      dialogs = state.dialogs || [];
      dialogs = dialogs.concat();
      dialogs.splice(action.index, 1);
      return { ...state, dialogs };
    case APP_CONFIRM:
      dialogs = state.dialogs || [];
      dialogs = dialogs.concat({ type: 'confirm', message: action.message });
      return { ...state, dialogs };
    case APP_PROMPT:
      dialogs = state.dialogs || [];
      dialogs = dialogs.concat({ type: 'prompt', message: action.message });
      return { ...state, dialogs };
    case APP_NOTIFY:
      let notifications = state.notifications || [];
      notifications = notifications.concat({
        dismissable: true,
        message: action.message,
      });
      return { ...state, notifications };
    default:
      return state;
  }
};
